import { EquipementBase } from '../equipement';
import { JsonProduct } from '../interface/context';

export class SimBase extends EquipementBase {
    /**
     * [constructor description]
     * @param data [description]
     * @return      [description]
     */
    constructor(data: JsonProduct, uniqueId: string) {
        super(data, uniqueId);
        this.price = this.getPrice();
    }
}
